import { formatMoneyString as sharedFormatMoneyString } from '@washday/utilities';
import cookies from 'js-cookie';

export const truncateText = (maxLength = 20, str = '') =>
  str.length > maxLength ? `${str.slice(0, maxLength)}...` : str;

export const formatMoneyString = (
  amount,
  decimalCount = 2,
  decimal = '.',
  thousands = ',',
  currencySymbol = cookies.get('currencySymbol') || '$'
) => {
  try {
    return sharedFormatMoneyString(amount, decimalCount, decimal, thousands, currencySymbol);
  } catch (e) {
    console.log(e);
  }
};

export const weekNumberToString = (weekNum) => {
  const weekNumsTranslation = {
    1: 'dayNames.monday',
    2: 'dayNames.tuesday',
    3: 'dayNames.wednesday',
    4: 'dayNames.thursday',
    5: 'dayNames.friday',
    6: 'dayNames.saturday',
    7: 'dayNames.sunday'
  };

  return weekNumsTranslation[weekNum];
};

export const ColorLabelOptions = [
  'red',
  'orange',
  'yellow',
  'green',
  'blue',
  'purple',
  'brown',
  'magenta',
  'tan',
  'cyan',
  'olive',
  'maroon',
  'navy',
  'aquamarine',
  'turquoise',
  'silver',
  'lime',
  'teal',
  'indigo',
  'violet',
  'pink',
  'black',
  'white',
  'gray'
];

export const StainLabelOptions = [
  'alcohol',
  'mud',
  'biro',
  'bleach',
  'coffee',
  'food',
  'setOfStains',
  'dirtyNeck',
  'grease',
  'makeup',
  'colorMargins',
  'mold',
  'fragrance',
  'Petroleum',
  'painting',
  'rust',
  'blood',
  'sweat',
  'ink',
  'wine'
];

export const DagamesLabelOptions = [
  'hole',
  'missingbutton',
  'brokenButton',
  'bubble',
  'tornNeck',
  'colorless',
  'brokenCuff',
  'ironBrand',
  'torn',
  'ironShine',
  'pillingFabric'
];

export const getWhatsappURLString = (phone: string = '', phoneCountryCode: string = '') => {
  phoneCountryCode = phoneCountryCode ?? '';
  phone = phone ?? '';
  if (!phone) return '';
  return `https://api.whatsapp.com/send?phone=${phoneCountryCode.replace('+', '')}${phone.replace(
    '+',
    ''
  )}`;
};

export const getCustomerFullName = (name: string = '', lastName: string = '') => {
  return [name, lastName].filter(Boolean).join(' ');
};

export const getFullPhoneNumber = (
  phoneCountryCode: string = '',
  phoneNumber: string = '',
  withPlusSign: boolean = false
): string => {
  // Trim any whitespace from the input values
  phoneCountryCode = phoneCountryCode ?? '';
  phoneNumber = phoneNumber ?? '';
  phoneCountryCode = phoneCountryCode.trim();
  phoneNumber = phoneNumber.trim();

  // Handle the case where phoneNumber is empty
  if (!phoneNumber) {
    // Option 1: Return an empty string
    return '';
  }

  // Return the concatenated phone country code and phone number
  const fullPhone = `${phoneCountryCode.replace('+', '')}${phoneNumber}`;
  return withPlusSign ? `+${fullPhone}` : fullPhone;
};
